module.exports = __webpack_public_path__ + "img/26-l.d494d079.png";